module.exports = __webpack_public_path__ + "img/ercode_gz.89eb87bb.png";